import { render } from "./SalesTracking.vue?vue&type=template&id=981248de&scoped=true"
import script from "./SalesTracking.vue?vue&type=script&lang=js"
export * from "./SalesTracking.vue?vue&type=script&lang=js"

import "./SalesTracking.vue?vue&type=style&index=0&id=981248de&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-981248de"]])

export default __exports__